// Copyright (c) 2025 Greener Power Solutions.
// This file is part of Greener Power Solutions' software,
// and may not be altered, copied, redistributed, or sold
// without specific permission.
import '../translations';
import { SidebarItems } from './[Project].sidebar';
import { ProjectProvider } from 'contexts/ProjectContext';
import { SocketProvider } from 'contexts/SocketContext';
import { Outlet, useParams } from 'react-router-dom';

export const ProjectLayout = () => {
  const { projectSlug } = useParams();

  return (
    <ProjectProvider projectSlug={projectSlug ?? ''}>
      <SidebarItems />
      <SocketProvider>
        <Outlet />
      </SocketProvider>
    </ProjectProvider>
  );
};
